/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { BackIcon, TrashIcon } from '../../../../../assets/icons';
import { OrdersService } from '../../../../../services';
import { Input } from '../../../../../components';
import SelectClient from '../../../panel/select-client';
import SelectRoute from '../../../panel/select-route';
import SelectDriver from '../../../panel/select-driver';
import SelectOwner from '../../../panel/select-owner';

const RouteDuplicate = () => {
  const { form, onChange, removeItem, submit } = useFetchTable();

  return (
    <main className="p-4 w-full">
      <div className="flex items-center gap-4">
        <Link to="/report/failures">
          <img src={BackIcon} className="w-6 h-6 object-contain cursor-pointer invert" alt="" />
        </Link>

        <h1 className="text-3xl font-bold">Duplicar viaje</h1>
      </div>
      <p className="text-default my-2">Para la planificación indica la nueva fecha</p>

      <div className="flex justify-between items-center my-4">
        <Input
          className={{ base: 'max-w-48' }}
          type="date"
          label="Fecha de viaje"
          value={form.date}
          onValueChange={v => onChange('date', v)}
        />

        <div className="flex gap-4">
          <Link to="/report/finished" className="px-4 py-2 bg-red text-white rounded-lg font-semibold">
            Cancelar
          </Link>
          <button
            className="px-4 py-2 bg-green text-white rounded-lg font-semibold disabled:opacity-50"
            onClick={submit}
            disabled={!form.items.length}
          >
            Aceptar
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md">
        <div className="">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-sm text-default font-semibold align-bottom">
                <th className="pl-4">Cliente</th>
                <th>Hora del viaje</th>
                <th>Conductor</th>
                <th>Placa de vehículo</th>
                <th>Ruta</th>
                <th>Propietario</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {form.items.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:max-w-36">
                  <td>
                    <SelectClient
                      value={item.user_id}
                      selectedLabel={item.user?.person?.company?.name}
                      onSelect={item => {
                        onChange('user_id', item?.id, index);
                        onChange('user', item, index);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      type="time"
                      value={item.time}
                      onValueChange={v => onChange('time', v, index)}
                    />
                  </td>
                  <td>
                    <SelectDriver
                      value={item.driver_id}
                      selectedLabel={item?.driver?.person?.fullName}
                      onSelect={item => {
                        onChange('driver_id', item?.id, index);
                        onChange('driver', item, index);
                        onChange('vehicle_id', item?.person?.driver?.vehicle_id, index);
                        onChange('vehicle', item?.person?.driver?.vehicle, index);
                        onChange('owner_id', item?.person?.driver?.vehicle?.owner_id, index);
                        onChange('owner', item?.person?.driver?.vehicle?.owner, index);
                      }}
                    />
                  </td>
                  <td>
                    <span className="font-semibold text-orange text-base">
                      { item?.vehicle?.plaque || '--' }
                    </span>
                  </td>
                  <td>
                    <SelectRoute
                      value={item.route_id}
                      selectedLabel={item?.route?.name}
                      onSelect={item => {
                        onChange('route_id', item?.id, index);
                        onChange('route', item, index);
                      }}
                    />
                  </td>
                  <td>
                    <SelectOwner
                      value={item.user_id}
                      selectedLabel={item?.vehicle?.owner?.person?.name}
                      onSelect={item => {
                        onChange('owner_id', item?.vehicle?.owner_id, index);
                        onChange('owner', item?.vehicle?.owner, index);
                        onChange('vehicle_id', item?.id, index);
                        onChange('vehicle', item, index);
                      }}
                    />
                  </td>
                  <td>
                    <img
                      src={TrashIcon}
                      className="w-5 h-5 object-contain cursor-pointer"
                      onClick={() => removeItem(index)}
                      alt=""
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!form.items.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialForm = {
    date: '',
    items: [],
  };

  const params = useParams();
  const nav = useNavigate();
  const [canFetch, setCanFetch] = useState(true);
  const [form, setForm] = useState(initialForm);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await OrdersService.moderator.findAllFinished({ date: params.date });
      const mapped = response.map(item => ({
        ...item,
        date: '',
        time: moment(item.date).format('HH:mm'),
        owner_id: item.vehicle?.owner_id,
        owner: item.vehicle?.owner,
      }));
      setForm(s => ({ ...s, items: mapped }));

    } catch (error) {
      toast.error(String(error));

    } finally {
      setCanFetch(true);
    }
  }

  const onChange = (target, value, index = null) => {
    if (Number.isInteger(index)) {
      setForm(s => ({ ...s, items: s.items.map((item, i) => i === index ? { ...item, [target]: value } : item) }));
    } else {
      setForm(s => ({ ...s, [target]: value }));
    }
  }

  const removeItem = (index) => {
    setForm(s => ({ ...s, items: s.items.filter((item, idx) => idx !== index) }));
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.items.length)
      return onError('Debes conservar al menos un viaje para confirmar la planificación');

    if (!form.date)
      return onError('Debe indicar la fecha del viaje');

    if (form.items.some(item => !item.user_id))
      return onError('Debe indicar el cliente de todos los viajes');

    if (form.items.some(item => !item.time))
      return onError('Debe indicar la hora de todos los viajes');

    if (form.items.some(item => !item.driver_id))
      return onError('Debe indicar el conductor de todos los viajes');

    if (form.items.some(item => !item.vehicle_id))
      return onError('Debe indicar el vehículo de todos los viajes');

    if (form.items.some(item => !item.route_id))
      return onError('Debe indicar la ruta de todos los viajes');

    return true;
  }

  const submit = async () => {
    if (!isValidForm()) return;

    try {
      const payload = {
        items: JSON.stringify(form.items.map(item => ({
          ...item,
          date: form.date,
        }))),
      };

      await OrdersService.moderator.duplicateDate(payload);
      toast.success('Viajes duplicados con éxito');
      nav('/report/finished', { replace: true });

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    form,
    isLoading: !canFetch,
    onChange,
    removeItem,
    search: fetchData,
    submit,
  }
}

export default RouteDuplicate;